import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { resourceDetailsQueryKeys } from './resourceDetailsQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';
import { parseVTT } from '../../mediaPlaying/utils/parseVTT.js';
import { isResourceStateProcessing } from '../../resources/utils/isResourceStateProcessing.js';
import { useMemo } from 'react';

const emptyTranscriptLines = [];
const useQueryResourceTranscript = (resource, options) => {
  const key = resourceDetailsQueryKeys.transcript(resource);
  const isProcessing = isResourceStateProcessing(resource?.stateProcessing);
  const query = useQuery({
    queryKey: key,
    queryFn: async (params) => {
      const safeTranscriptPath = params.queryKey[2];
      return await parseVTT(safeTranscriptPath);
    },
    placeholderData: keepPreviousData,
    staleTime: 1e3 * 60 * 60 * 24,
    ...options,
    enabled: isQueryEnabled([
      key.length > 0,
      !isProcessing,
      options?.enabled
    ])
  });
  return {
    ...query,
    transcriptLines: useMemo(() => {
      const hasTranscript = key.length > 0;
      if (isProcessing && resource?.kind !== "bookmark") return emptyTranscriptLines;
      if (!hasTranscript) return null;
      if (query.data?.length === 0) return null;
      if (query.error) return null;
      return query.data ?? emptyTranscriptLines;
    }, [
      query.data,
      key.length,
      isProcessing,
      query.error,
      resource?.kind
    ])
  };
};

export { useQueryResourceTranscript };
//# sourceMappingURL=useQueryResourceTranscript.js.map
